<div class="map-wrapper">
  <div #mapContainer class="map-container" [style.height]="height">
    <div class="map-loading" *ngIf="!mapLoaded">
      <i class="pi pi-spin pi-spinner"></i>
      <span style="color: #0B0C0E">Loading map...</span>
    </div>
  </div>


  <!-- Zoom Controls -->
  <div class="zoom-controls">
    <button pButton class="p-button-rounded p-button-text" (click)="zoomIn()" pTooltip="Zoom avant" tooltipPosition="left">
      <i class="pi pi-plus"></i>
    </button>
    <button pButton class="p-button-rounded p-button-text" (click)="zoomOut()" pTooltip="Zoom arrière" tooltipPosition="top">
      <i class="pi pi-minus"></i>
    </button>
  </div>

  <!-- Draw Control -->
  <div class="draw-control">
    <!--    <button-->
    <!--      pButton-->
    <!--      class="p-button-rounded p-button-text"-->
    <!--      [class.active]="drawingMode"-->
    <!--      (click)="toggleDrawing()">-->
    <!--      <i class="pi pi-pencil"></i>-->
    <!--    </button>-->
    <button
      pButton
      class="p-button-rounded p-button-text"
      [class.active]="drawingMode"

      (click)="centerMap()">
      <img
        [src]="'map-center' | iconPath"
        alt="Map"
        class="map-icon"
      />
    </button>
  </div>

  <!-- Image Control -->
  <div class="image-control flex flex-column gap-1">
    <button
      pButton
      class="p-button-rounded p-button-text"
      (click)="toggleSatelliteLayer()">
      <img
        [src]="'download-satellite-data' | iconPath"
        alt="Map"
        class="map-icon"
      />
    </button>

    <button
      pButton
      class="p-button-rounded p-button-text"
      (click)="stopPolygonDrawing()">
      <img
        [src]="'map-draw-point' | iconPath"
        alt="Map"
        class="map-icon"
      />
    </button>
    <button
      pButton
      class="p-button-rounded p-button-text"
      (click)="startPolygonDrawing()">
      <img
        [src]="'map-draw-polygon' | iconPath"
        alt="Map"
        class="map-icon"
      />
    </button>
  </div>


</div>
